/* eslint-disable css-modules/no-unused-class  */
import { FC, useState } from 'react';
import { Icon } from 'learning-panel-components';
import styles from './skillTreePathButton.module.scss';

const SkillTreePathButton: FC<SkillTreePathButtonProps> = (props: SkillTreePathButtonProps) => {
    const { name, numberOfItems, isActive, onClick, onInformationClick } = props;
    const [isHovered, setIsHovered] = useState<boolean>(false);

    return (
        <div
            onMouseOver={(): void => setIsHovered(true)}
            onMouseLeave={(): void => setIsHovered(false)}
            className={isActive ? styles['active-skill-tree-path-button'] : styles['skill-tree-path-button']}
            onClick={() => onClick()}
        >
            {isActive && (
                <img
                    src={`${process.env.PUBLIC_URL}/images/skillTreeItemGlow.svg`}
                    className={styles.glow}
                    alt="skillTreeButton"
                />
            )}
            <img
                alt="activeSkillTreebutton"
                src={
                    isActive
                        ? `${process.env.PUBLIC_URL}/images/activeSkillTreePathButton.svg`
                        : `${process.env.PUBLIC_URL}/images/skillTreePathButton.svg`
                }
                className={isHovered && !isActive ? styles['hovered-button'] : styles.button}
            />
            {isHovered && !isActive && (
                <div
                    className={styles['information-wrapper']}
                    onClick={e => {
                        onInformationClick();
                        e.stopPropagation();
                    }}
                >
                    <Icon name="info" />
                    <div>{numberOfItems}</div>
                </div>
            )}
            <div className={styles.name} title={name}>
                {name}
            </div>
        </div>
    );
};

export default SkillTreePathButton;

export interface SkillTreePathButtonProps {
    name: string;
    numberOfItems: string;
    isActive: boolean;
    onClick: Function;
    onInformationClick: Function;
}
